'use client';

import { useQuery } from '@tanstack/react-query';

import api from '@/lib/api';
import { publicCommentUserCommentsQueryKey } from './helpers';

/**
 * The signed-in citizen's own comments on a meeting. Shared by the comment dialog and the
 * meeting-page card so both read the same cache entry and a deletion in one updates the other.
 */
export const useUserComments = (governmentCode: string, meetingId: number, enabled = true) =>
  useQuery({
    enabled,
    queryKey: publicCommentUserCommentsQueryKey(governmentCode, meetingId),
    queryFn: () => api.governments.publicComments(governmentCode, meetingId).getUserComments(),
    refetchOnMount: 'always',
  });
